module.exports = __webpack_public_path__ + "static/media/ic_wcag_contrast.36c3b218.svg";